// import { useLocation, useNavigate, Link } from "react-router-dom";
// import React, { useEffect, useState, useContext } from "react";
// import { SicunetIcon } from "../Icons/Sicunet";
// import NeptuneAccessDropdown from "../inputWidgets/RequestDemo";
// import { FaUserCircle, FaChevronDown } from "react-icons/fa";
// import { LoginContext } from "../../../lib/loginContext";
// import { RiLogoutBoxLine } from "react-icons/ri";
// import ProfileIcon from "../../../assets/svg/profileIcon";
// import DemoLoginModal from "../../../modules/DemoPwd/DemoLoginModal";
// import useSWR from "swr";
// import { fetcher } from "../../../lib/api";
// import { EnhancedDropdown } from "../inputWidgets/EnhancedDropdown ";
// import {
//   getProductItems,
//   getKeyFeaturesItems,
//   getSupportItems,
// } from "./navbarUtils";

// const NavBar = () => {
//   const navigate = useNavigate();
//   let location = useLocation();
//   const { isLoggedIn, userName, roleName, userId, logout } =
//     useContext(LoginContext);
//   const isProductPage = location.pathname.startsWith("/product/");
//   const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
//   const [userDropdownOpen, setUserDropdownOpen] = useState(false);
//   const [logoutMessage, setLogoutMessage] = useState("");
//   const [menu, setMenu] = useState("Home");
//   const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
//   const [demoModalOpen, setDemoModalOpen] = useState(false);
//   const [mobileProductOpen, setMobileProductOpen] = useState(false);
//   const [mobileKeyFeaturesOpen, setMobileKeyFeaturesOpen] = useState(false);
//   const [mobileSupportOpen, setMobileSupportOpen] = useState(false);

//   // State to manage which dropdown is open
//   const [openDropdown, setOpenDropdown] = useState(null);

//   // Fetch categories
//   const {
//     data: categories,
//     isLoading: categoriesLoading,
//     error: categoriesError,
//   } = useSWR("/categories/", fetcher);

//   const toggleNavbar = () => {
//     setMobileDrawerOpen(!mobileDrawerOpen);
//   };

//   const toggleUserDropdown = () => {
//     setUserDropdownOpen(!userDropdownOpen);
//   };

//   const handleLogout = () => {
//     logout();
//     setUserDropdownOpen(false);
//     setMobileDrawerOpen(false);

//     setLogoutMessage("Logged out successfully");

//     setTimeout(() => {
//       setLogoutMessage("");
//     }, 900);

//     navigate("/");
//   };

//   // Handle dropdown toggle for desktop
//   const handleDropdownToggle = (dropdownName) => {
//     setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
//   };

//   // Handle Request Demo click - close mobile drawer
//   const handleRequestDemoClick = () => {
//     setMobileDrawerOpen(false);
//   };

//   // Close mobile drawer when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       const drawer = document.getElementById("mobile-drawer");
//       const dropdown = document.querySelector(".ant-dropdown");
//       const userDropdown = document.getElementById("user-dropdown");
//       const menuButton = document.getElementById("mobile-menu-button");

//       if (
//         mobileDrawerOpen &&
//         drawer &&
//         !drawer.contains(event.target) &&
//         (!dropdown || !dropdown.contains(event.target)) &&
//         (!menuButton || !menuButton.contains(event.target))
//       ) {
//         setMobileDrawerOpen(false);
//       }

//       if (
//         userDropdownOpen &&
//         userDropdown &&
//         !userDropdown.contains(event.target) &&
//         !event.target.closest(".user-dropdown-trigger")
//       ) {
//         setUserDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [mobileDrawerOpen, userDropdownOpen]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsDesktop(window.innerWidth >= 768);
//     };
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Get menu items from utility functions
//   const productItems = getProductItems(categories);
//   const items = getKeyFeaturesItems();
//   const supportItems = getSupportItems(isLoggedIn);

//   return (
//     <>
//       <div className="fixed bg-gray-50 z-20 w-full shadow-md border-b border-gray-200">
//         <div className="flex justify-between items-center py-2.5 px-6 lg:px-12 max-w-[1400px] 2xl:max-w-[1800px] mx-auto">
//           {" "}
//           {/* Left Section - Logo */}
//           <div className="flex items-center">
//             <div
//               className="cursor-pointer"
//               onClick={() => {
//                 navigate("/");
//                 setMenu("Home");
//               }}
//             >
//               <SicunetIcon />
//             </div>
//           </div>
//           {/* Center Section - Menu Items */}
//           <div className="hidden lg:flex items-center gap-14">
//             <div
//               className={`relative text-[13px] font-semibold tracking-wide cursor-pointer transition-colors ${
//                 location.pathname === "/"
//                   ? "text-[#016FFC]"
//                   : "text-gray-800 hover:text-[#016FFC]"
//               }`}
//               onClick={() => {
//                 navigate("/");
//                 setMenu("Home");
//               }}
//             >
//               Home
//             </div>
//             <div
//               className={`relative text-[13px] font-semibold tracking-wide cursor-pointer transition-colors ${
//                 location.pathname === "/company"
//                   ? "text-[#016FFC]"
//                   : "text-gray-800 hover:text-[#016FFC]"
//               }`}
//               onClick={() => {
//                 navigate("/company");
//                 setMenu("Company");
//               }}
//             >
//               Company
//             </div>
//             <div
//               className={`relative text-[13px] font-semibold tracking-wide flex items-center gap-2 transition-colors ${
//                 location.pathname === "/product" ||
//                 productItems.some(
//                   (item) =>
//                     item.link === `${location.pathname}${location.search}`
//                 )
//                   ? "text-[#016FFC]"
//                   : "text-gray-800 hover:text-[#016FFC]"
//               }`}
//             >
//               <EnhancedDropdown
//                 items={productItems}
//                 label="Products"
//                 isProductPage={isProductPage}
//                 currentPath={location.pathname}
//                 currentSearch={location.search}
//                 isOpen={openDropdown === "products"}
//                 onOpenChange={(isOpen) =>
//                   setOpenDropdown(isOpen ? "products" : null)
//                 }
//                 isProductDropdown={true}
//               />
//               <FaChevronDown
//                 className="text-[9px] mt-[2px] cursor-pointer"
//                 onClick={() => handleDropdownToggle("products")}
//               />
//             </div>
//             <div
//               className={`relative text-[13px] font-semibold tracking-wide flex items-center gap-2 transition-colors ${
//                 items.some((item) => item.link === location.pathname)
//                   ? "text-[#016FFC]"
//                   : "text-gray-800 hover:text-[#016FFC]"
//               }`}
//             >
//               <EnhancedDropdown
//                 items={items}
//                 label="Key Features"
//                 isProductPage={isProductPage}
//                 currentPath={location.pathname}
//                 isOpen={openDropdown === "features"}
//                 onOpenChange={(isOpen) =>
//                   setOpenDropdown(isOpen ? "features" : null)
//                 }
//               />
//               <FaChevronDown
//                 className="text-[9px] mt-[2px] cursor-pointer"
//                 onClick={() => handleDropdownToggle("features")}
//               />
//             </div>
//             <div
//               className={`relative text-[13px] font-semibold tracking-wide flex items-center gap-2 transition-colors ${
//                 supportItems.some((item) => item.link === location.pathname)
//                   ? "text-[#016FFC]"
//                   : "text-gray-800 hover:text-[#016FFC]"
//               }`}
//             >
//               <EnhancedDropdown
//                 items={supportItems}
//                 label="Support"
//                 isProductPage={isProductPage}
//                 currentPath={location.pathname}
//                 onDemoClick={() => setDemoModalOpen(true)}
//                 isOpen={openDropdown === "support"}
//                 onOpenChange={(isOpen) =>
//                   setOpenDropdown(isOpen ? "support" : null)
//                 }
//               />
//               <FaChevronDown
//                 className="text-[9px] mt-[2px] cursor-pointer"
//                 onClick={() => handleDropdownToggle("support")}
//               />
//             </div>
//           </div>
//           {/* Right Section - Request Demo + Login */}
//           <div className="flex items-center gap-4">
//             {/* Mobile menu toggle - visible on mobile */}
//             <div className="lg:hidden">
//               <button
//                 id="mobile-menu-button"
//                 onClick={toggleNavbar}
//                 className="p-2 hover:bg-gray-100 rounded-lg transition-all"
//                 style={{ color: "#1a1a1a" }}
//                 aria-label={mobileDrawerOpen ? "Close menu" : "Open menu"}
//               >
//                 {mobileDrawerOpen ? (
//                   <svg
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <line x1="18" y1="6" x2="6" y2="18"></line>
//                     <line x1="6" y1="6" x2="18" y2="18"></line>
//                   </svg>
//                 ) : (
//                   <svg
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <line x1="3" y1="12" x2="21" y2="12"></line>
//                     <line x1="3" y1="6" x2="21" y2="6"></line>
//                     <line x1="3" y1="18" x2="21" y2="18"></line>
//                   </svg>
//                 )}
//               </button>
//             </div>

//             {/* Desktop items - hidden on mobile */}
//             <div className="hidden lg:flex items-center gap-6">
//               <NeptuneAccessDropdown />
//               {isLoggedIn ? (
//                 <div className="relative">
//                   <button
//                     onClick={toggleUserDropdown}
//                     className="user-dropdown-trigger flex items-center gap-2 text-gray-800 text-[13px] font-medium rounded-full px-2 py-1 hover:bg-gray-100 transition-all"
//                   >
//                     <ProfileIcon className="w-7 h-7 rounded-full" />
//                   </button>
//                   {userDropdownOpen && (
//                     <div
//                       id="user-dropdown"
//                       className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl py-2 z-50 border border-gray-200"
//                     >
//                       <div className="px-4 py-2 border-b border-gray-100">
//                         <p className="text-sm font-medium text-gray-800 truncate">
//                           {roleName || "Super Admin"}
//                         </p>
//                       </div>
//                       <button
//                         onClick={handleLogout}
//                         className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-50 flex items-center gap-2 transition-colors"
//                       >
//                         <RiLogoutBoxLine size={18} />
//                         Logout
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <Link
//                   to="/login"
//                   className="text-[13px] font-semibold tracking-wide text-gray-800 hover:text-[#016FFC] transition-colors border-2 border-gray-800 hover:border-[#016FFC] px-4 py-1 rounded-md"
//                 >
//                   Login
//                 </Link>
//               )}
//             </div>
//           </div>
//         </div>

//         {mobileDrawerOpen && (
//           <div
//             id="mobile-drawer"
//             className="fixed top-[60px] left-0 right-0 bottom-0 z-30 bg-white w-full overflow-y-auto lg:hidden border-t border-gray-200 shadow-lg"
//           >
//             <div className="p-6">
//               <ul className="space-y-1">
//                 <li
//                   className={`text-[13px] font-medium tracking-wide py-3 px-4 rounded-lg transition-colors cursor-pointer ${
//                     location.pathname === "/"
//                       ? "bg-blue-50 text-[#016FFC]"
//                       : "text-gray-700 hover:bg-gray-50"
//                   }`}
//                   onClick={() => {
//                     navigate("/");
//                     setMenu("Home");
//                     setMobileDrawerOpen(false);
//                   }}
//                 >
//                   Home
//                 </li>
//                 <li
//                   className={`text-[13px] font-medium tracking-wide py-3 px-4 rounded-lg transition-colors cursor-pointer ${
//                     location.pathname === "/company"
//                       ? "bg-blue-50 text-[#016FFC]"
//                       : "text-gray-700 hover:bg-gray-50"
//                   }`}
//                   onClick={() => {
//                     navigate("/company");
//                     setMenu("Company");
//                     setMobileDrawerOpen(false);
//                   }}
//                 >
//                   Company
//                 </li>

//                 {/* Product Submenu */}
//                 <li className="py-2">
//                   <div
//                     onClick={() => setMobileProductOpen(!mobileProductOpen)}
//                     className={`text-[13px] font-medium tracking-wide py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${
//                       location.pathname === "/product" ||
//                       productItems.some(
//                         (item) =>
//                           item.link === `${location.pathname}${location.search}`
//                       )
//                         ? "bg-blue-50 text-[#016FFC]"
//                         : "text-gray-700 hover:bg-gray-50"
//                     }`}
//                   >
//                     Products
//                     <FaChevronDown
//                       className={`text-[10px] transition-transform ${
//                         mobileProductOpen ? "rotate-180" : ""
//                       }`}
//                     />
//                   </div>
//                   {mobileProductOpen && (
//                     <ul className="ml-4 mt-2 space-y-1">
//                       {productItems.map((item) => (
//                         <li
//                           key={item.key}
//                           onClick={() => {
//                             navigate(item.link);
//                             setMobileDrawerOpen(false);
//                             setMobileProductOpen(false);
//                           }}
//                           className={`text-[13px] py-2 px-4 rounded-lg cursor-pointer transition-colors ${
//                             item.link ===
//                             `${location.pathname}${location.search}`
//                               ? "bg-blue-50 text-[#016FFC] font-medium"
//                               : "text-gray-600 hover:bg-gray-50"
//                           }`}
//                         >
//                           {item.label}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>

//                 {/* Key Features Submenu */}
//                 <li className="py-2">
//                   <div
//                     onClick={() =>
//                       setMobileKeyFeaturesOpen(!mobileKeyFeaturesOpen)
//                     }
//                     className={`text-[13px] font-medium tracking-wide py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${
//                       items.some((item) => item.link === location.pathname)
//                         ? "bg-blue-50 text-[#016FFC]"
//                         : "text-gray-700 hover:bg-gray-50"
//                     }`}
//                   >
//                     Key Features
//                     <FaChevronDown
//                       className={`text-[10px] transition-transform ${
//                         mobileKeyFeaturesOpen ? "rotate-180" : ""
//                       }`}
//                     />
//                   </div>
//                   {mobileKeyFeaturesOpen && (
//                     <ul className="ml-4 mt-2 space-y-1">
//                       {items.map((item) => (
//                         <li
//                           key={item.key}
//                           onClick={() => {
//                             navigate(item.link);
//                             setMobileDrawerOpen(false);
//                             setMobileKeyFeaturesOpen(false);
//                           }}
//                           className={`text-[13px] py-2 px-4 rounded-lg cursor-pointer transition-colors ${
//                             item.link === location.pathname
//                               ? "bg-blue-50 text-[#016FFC] font-medium"
//                               : "text-gray-600 hover:bg-gray-50"
//                           }`}
//                         >
//                           {item.label}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>

//                 {/* Support Submenu */}
//                 <li className="py-2">
//                   <div
//                     onClick={() => setMobileSupportOpen(!mobileSupportOpen)}
//                     className={`text-[13px] font-medium tracking-wide py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${
//                       supportItems.some(
//                         (item) => item.link === location.pathname
//                       )
//                         ? "bg-blue-50 text-[#016FFC]"
//                         : "text-gray-700 hover:bg-gray-50"
//                     }`}
//                   >
//                     Support
//                     <FaChevronDown
//                       className={`text-[10px] transition-transform ${
//                         mobileSupportOpen ? "rotate-180" : ""
//                       }`}
//                     />
//                   </div>
//                   {mobileSupportOpen && (
//                     <ul className="ml-4 mt-2 space-y-1">
//                       {supportItems.map((item) => (
//                         <li
//                           key={item.key}
//                           onClick={() => {
//                             if (item.link === "#demo") {
//                               setDemoModalOpen(true);
//                               setMobileDrawerOpen(false);
//                               setMobileSupportOpen(false);
//                             } else if (item.link.startsWith("http")) {
//                               window.open(item.link, "_blank");
//                             } else {
//                               navigate(item.link);
//                               setMobileDrawerOpen(false);
//                               setMobileSupportOpen(false);
//                             }
//                           }}
//                           className={`text-[13px] py-2 px-4 rounded-lg cursor-pointer transition-colors ${
//                             item.link === location.pathname
//                               ? "bg-blue-50 text-[#016FFC] font-medium"
//                               : "text-gray-600 hover:bg-gray-50"
//                           }`}
//                         >
//                           {item.label}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>
//               </ul>

//               {/* Bottom Actions */}
//               <div className="mt-8 pt-6 border-t border-gray-200 space-y-4">
//                 <div className="px-4">
//                   <NeptuneAccessDropdown
//                     onRequestDemo={handleRequestDemoClick}
//                   />
//                 </div>
//                 <div className="px-4">
//                   {isLoggedIn ? (
//                     <div className="flex flex-col items-center gap-3 py-4 bg-gray-50 rounded-lg">
//                       <div className="flex items-center gap-2 text-gray-700">
//                         <FaUserCircle size={20} />
//                         <span className="text-[13px] font-medium">
//                           {roleName || "Super Admin"}
//                         </span>
//                       </div>
//                       <button
//                         onClick={handleLogout}
//                         className="text-[13px] font-medium border-2 border-red-500 text-red-500 rounded-lg px-6 py-2 hover:bg-red-500 hover:text-white transition-all flex items-center gap-2 tracking-wide"
//                       >
//                         <RiLogoutBoxLine size={16} />
//                         Logout
//                       </button>
//                     </div>
//                   ) : (
//                     <Link
//                       to="/login"
//                       onClick={() => setMobileDrawerOpen(false)}
//                       className="block text-center text-[13px] font-medium tracking-wide text-gray-700 border-2 border-gray-300 rounded-lg px-6 py-2 hover:bg-gray-100 transition-colors"
//                     >
//                       Login
//                     </Link>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <DemoLoginModal
//         isOpen={demoModalOpen}
//         onClose={() => setDemoModalOpen(false)}
//       />
//       {/* Logout Success Message */}
//       {logoutMessage && (
//         <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-[9999] animate-slideInFromBottom">
//           <div className="bg-red-500 text-white px-5 py-2.5 rounded-lg shadow-xl flex items-center space-x-2">
//             <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//               <path
//                 fillRule="evenodd"
//                 d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
//                 clipRule="evenodd"
//               />
//             </svg>
//             <p className="font-semibold text-sm">{logoutMessage}</p>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes slideInFromBottom {
//           from {
//             opacity: 0;
//             transform: translate(-50%, 20px);
//           }
//           to {
//             opacity: 1;
//             transform: translate(-50%, 0);
//           }
//         }

//         .animate-slideInFromBottom {
//           animation: slideInFromBottom 0.5s ease-out forwards;
//         }
//       `}</style>
//     </>
//   );
// };

// export default NavBar;
// import { useLocation, useNavigate, Link } from "react-router-dom";
// import React, { useEffect, useState, useContext } from "react";
// import { SicunetIcon } from "../Icons/Sicunet";
// import NeptuneAccessDropdown from "../inputWidgets/RequestDemo";
// import { FaUserCircle, FaChevronDown } from "react-icons/fa";
// import { LoginContext } from "../../../lib/loginContext";
// import { RiLogoutBoxLine } from "react-icons/ri";
// import ProfileIcon from "../../../assets/svg/profileIcon";
// import DemoLoginModal from "../../../modules/DemoPwd/DemoLoginModal";
// import useSWR from "swr";
// import { fetcher } from "../../../lib/api";
// import { EnhancedDropdown } from "../inputWidgets/EnhancedDropdown ";
// import {
//   getProductItems,
//   getKeyFeaturesItems,
//   getSupportItems,
// } from "./navbarUtils";

// const NavBar = () => {
//   const navigate = useNavigate();
//   let location = useLocation();
//   const { isLoggedIn, userName, roleName, userId, logout } =
//     useContext(LoginContext);
//   const isProductPage = location.pathname.startsWith("/product/");
//   const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
//   const [userDropdownOpen, setUserDropdownOpen] = useState(false);
//   const [logoutMessage, setLogoutMessage] = useState("");
//   const [menu, setMenu] = useState("Home");
//   const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
//   const [demoModalOpen, setDemoModalOpen] = useState(false);
//   const [mobileProductOpen, setMobileProductOpen] = useState(false);
//   const [mobileKeyFeaturesOpen, setMobileKeyFeaturesOpen] = useState(false);
//   const [mobileSupportOpen, setMobileSupportOpen] = useState(false);

//   // State to manage which dropdown is open
//   const [openDropdown, setOpenDropdown] = useState(null);

//   // Fetch categories
//   const {
//     data: categories,
//     isLoading: categoriesLoading,
//     error: categoriesError,
//   } = useSWR("/categories/", fetcher);

//   const toggleNavbar = () => {
//     setMobileDrawerOpen(!mobileDrawerOpen);
//   };

//   const toggleUserDropdown = () => {
//     setUserDropdownOpen(!userDropdownOpen);
//   };

//   const handleLogout = () => {
//     logout();
//     setUserDropdownOpen(false);
//     setMobileDrawerOpen(false);

//     setLogoutMessage("Logged out successfully");

//     setTimeout(() => {
//       setLogoutMessage("");
//     }, 900);

//     navigate("/");
//   };

//   // Handle dropdown toggle for desktop
//   const handleDropdownToggle = (dropdownName) => {
//     setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
//   };

//   // Handle Request Demo click - close mobile drawer
//   const handleRequestDemoClick = () => {
//     setMobileDrawerOpen(false);
//   };

//   // Close mobile drawer when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       const drawer = document.getElementById("mobile-drawer");
//       const dropdown = document.querySelector(".ant-dropdown");
//       const userDropdown = document.getElementById("user-dropdown");
//       const menuButton = document.getElementById("mobile-menu-button");

//       if (
//         mobileDrawerOpen &&
//         drawer &&
//         !drawer.contains(event.target) &&
//         (!dropdown || !dropdown.contains(event.target)) &&
//         (!menuButton || !menuButton.contains(event.target))
//       ) {
//         setMobileDrawerOpen(false);
//       }

//       if (
//         userDropdownOpen &&
//         userDropdown &&
//         !userDropdown.contains(event.target) &&
//         !event.target.closest(".user-dropdown-trigger")
//       ) {
//         setUserDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [mobileDrawerOpen, userDropdownOpen]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsDesktop(window.innerWidth >= 768);
//     };
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Get menu items from utility functions
//   const productItems = getProductItems(categories);
//   const items = getKeyFeaturesItems();
//   const supportItems = getSupportItems(isLoggedIn);

//   return (
//     <>
//       <div className="fixed bg-white z-20 w-full shadow-sm border-b border-gray-100">
//         <div className="flex justify-between items-center py-[11px] px-6 lg:px-12 max-w-[1400px] 2xl:max-w-[1800px] mx-auto">
//           {" "}
//           {/* Left Section - Logo */}
//           <div className="flex items-center">
//             <div
//               className="cursor-pointer"
//               onClick={() => {
//                 navigate("/");
//                 setMenu("Home");
//               }}
//             >
//               <SicunetIcon />
//             </div>
//           </div>
//           {/* Center Section - Menu Items */}
//           <div className="hidden lg:flex items-center  gap-[66px]">
//             <div
//               className={`relative text-sm font-medium tracking-normal cursor-pointer transition-colors ${
//                 location.pathname === "/"
//                   ? "text-[#016FFC]"
//                   : "text-gray-900 hover:text-[#016FFC]"
//               }`}
//               onClick={() => {
//                 navigate("/");
//                 setMenu("Home");
//               }}
//             >
//               Home
//             </div>
//             <div
//               className={`relative text-sm font-medium tracking-normal cursor-pointer transition-colors ${
//                 location.pathname === "/company"
//                   ? "text-[#016FFC]"
//                   : "text-gray-900 hover:text-[#016FFC]"
//               }`}
//               onClick={() => {
//                 navigate("/company");
//                 setMenu("Company");
//               }}
//             >
//               Company
//             </div>
//             <div
//               className={`relative text-sm font-medium tracking-normal flex items-center gap-2 transition-colors ${
//                 location.pathname === "/product" ||
//                 productItems.some(
//                   (item) =>
//                     item.link === `${location.pathname}${location.search}`
//                 )
//                   ? "text-[#016FFC]"
//                   : "text-gray-900 hover:text-[#016FFC]"
//               }`}
//             >
//               <EnhancedDropdown
//                 items={productItems}
//                 label="Products"
//                 isProductPage={isProductPage}
//                 currentPath={location.pathname}
//                 currentSearch={location.search}
//                 isOpen={openDropdown === "products"}
//                 onOpenChange={(isOpen) =>
//                   setOpenDropdown(isOpen ? "products" : null)
//                 }
//                 isProductDropdown={true}
//               />
//               <FaChevronDown
//                 className="text-[10px] mt-[1px] cursor-pointer"
//                 onClick={() => handleDropdownToggle("products")}
//               />
//             </div>
//             <div
//               className={`relative text-sm font-medium tracking-normal flex items-center gap-2 transition-colors ${
//                 items.some((item) => item.link === location.pathname)
//                   ? "text-[#016FFC]"
//                   : "text-gray-900 hover:text-[#016FFC]"
//               }`}
//             >
//               <EnhancedDropdown
//                 items={items}
//                 label="Key Features"
//                 isProductPage={isProductPage}
//                 currentPath={location.pathname}
//                 isOpen={openDropdown === "features"}
//                 onOpenChange={(isOpen) =>
//                   setOpenDropdown(isOpen ? "features" : null)
//                 }
//               />
//               <FaChevronDown
//                 className="text-[10px] mt-[1px] cursor-pointer"
//                 onClick={() => handleDropdownToggle("features")}
//               />
//             </div>
//             <div
//               className={`relative text-sm font-medium tracking-normal flex items-center gap-2 transition-colors ${
//                 supportItems.some((item) => item.link === location.pathname)
//                   ? "text-[#016FFC]"
//                   : "text-gray-900 hover:text-[#016FFC]"
//               }`}
//             >
//               <EnhancedDropdown
//                 items={supportItems}
//                 label="Support"
//                 isProductPage={isProductPage}
//                 currentPath={location.pathname}
//                 onDemoClick={() => setDemoModalOpen(true)}
//                 isOpen={openDropdown === "support"}
//                 onOpenChange={(isOpen) =>
//                   setOpenDropdown(isOpen ? "support" : null)
//                 }
//               />
//               <FaChevronDown
//                 className="text-[10px] mt-[1px] cursor-pointer"
//                 onClick={() => handleDropdownToggle("support")}
//               />
//             </div>
//           </div>
//           {/* Right Section - Request Demo + Login */}
//           <div className="flex items-center gap-4">
//             {/* Mobile menu toggle - visible on mobile */}
//             <div className="lg:hidden">
//               <button
//                 id="mobile-menu-button"
//                 onClick={toggleNavbar}
//                 className="p-2 hover:bg-gray-50 rounded-lg transition-all"
//                 style={{ color: "#1a1a1a" }}
//                 aria-label={mobileDrawerOpen ? "Close menu" : "Open menu"}
//               >
//                 {mobileDrawerOpen ? (
//                   <svg
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <line x1="18" y1="6" x2="6" y2="18"></line>
//                     <line x1="6" y1="6" x2="18" y2="18"></line>
//                   </svg>
//                 ) : (
//                   <svg
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <line x1="3" y1="12" x2="21" y2="12"></line>
//                     <line x1="3" y1="6" x2="21" y2="6"></line>
//                     <line x1="3" y1="18" x2="21" y2="18"></line>
//                   </svg>
//                 )}
//               </button>
//             </div>

//             {/* Desktop items - hidden on mobile */}
//             <div className="hidden lg:flex items-center gap-4">
//               <NeptuneAccessDropdown />
//               {isLoggedIn ? (
//                 <div className="relative">
//                   <button
//                     onClick={toggleUserDropdown}
//                     className="user-dropdown-trigger flex items-center gap-2 text-gray-900 text-sm font-medium rounded-full px-2 py-1 hover:bg-gray-50 transition-all"
//                   >
//                     <ProfileIcon className="w-8 h-8 rounded-full" />
//                   </button>
//                   {userDropdownOpen && (
//                     <div
//                       id="user-dropdown"
//                       className="absolute right-0 mt-2 w-52 bg-white rounded-xl shadow-lg py-2 z-50 border border-gray-100"
//                     >
//                       <div className="px-4 py-3 border-b border-gray-100">
//                         <p className="text-sm font-semibold text-gray-900 truncate">
//                           {roleName || "Super Admin"}
//                         </p>
//                       </div>
//                       <button
//                         onClick={handleLogout}
//                         className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 transition-colors font-medium"
//                       >
//                         <RiLogoutBoxLine size={18} />
//                         Logout
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <Link
//                   to="/login"
//                   className="text-sm font-medium tracking-normal text-gray-900 hover:text-[#016FFC] transition-colors border-2 border-gray-300 hover:border-[#016FFC] px-5 py-1.5 rounded-lg"
//                 >
//                   Login
//                 </Link>
//               )}
//             </div>
//           </div>
//         </div>

//         {mobileDrawerOpen && (
//           <div
//             id="mobile-drawer"
//             className="fixed top-[64px] left-0 right-0 bottom-0 z-30 bg-white w-full overflow-y-auto lg:hidden border-t border-gray-100 shadow-lg"
//           >
//             <div className="p-6">
//               <ul className="space-y-1">
//                 <li
//                   className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg transition-colors cursor-pointer ${
//                     location.pathname === "/"
//                       ? "bg-blue-50 text-[#016FFC]"
//                       : "text-gray-900 hover:bg-gray-50"
//                   }`}
//                   onClick={() => {
//                     navigate("/");
//                     setMenu("Home");
//                     setMobileDrawerOpen(false);
//                   }}
//                 >
//                   Home
//                 </li>
//                 <li
//                   className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg transition-colors cursor-pointer ${
//                     location.pathname === "/company"
//                       ? "bg-blue-50 text-[#016FFC]"
//                       : "text-gray-900 hover:bg-gray-50"
//                   }`}
//                   onClick={() => {
//                     navigate("/company");
//                     setMenu("Company");
//                     setMobileDrawerOpen(false);
//                   }}
//                 >
//                   Company
//                 </li>

//                 {/* Product Submenu */}
//                 <li className="py-2">
//                   <div
//                     onClick={() => setMobileProductOpen(!mobileProductOpen)}
//                     className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${
//                       location.pathname === "/product" ||
//                       productItems.some(
//                         (item) =>
//                           item.link === `${location.pathname}${location.search}`
//                       )
//                         ? "bg-blue-50 text-[#016FFC]"
//                         : "text-gray-900 hover:bg-gray-50"
//                     }`}
//                   >
//                     Products
//                     <FaChevronDown
//                       className={`text-[10px] transition-transform ${
//                         mobileProductOpen ? "rotate-180" : ""
//                       }`}
//                     />
//                   </div>
//                   {mobileProductOpen && (
//                     <ul className="ml-4 mt-2 space-y-1">
//                       {productItems.map((item) => (
//                         <li
//                           key={item.key}
//                           onClick={() => {
//                             navigate(item.link);
//                             setMobileDrawerOpen(false);
//                             setMobileProductOpen(false);
//                           }}
//                           className={`text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors ${
//                             item.link ===
//                             `${location.pathname}${location.search}`
//                               ? "bg-blue-50 text-[#016FFC] font-medium"
//                               : "text-gray-600 hover:bg-gray-50"
//                           }`}
//                         >
//                           {item.label}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>

//                 {/* Key Features Submenu */}
//                 <li className="py-2">
//                   <div
//                     onClick={() =>
//                       setMobileKeyFeaturesOpen(!mobileKeyFeaturesOpen)
//                     }
//                     className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${
//                       items.some((item) => item.link === location.pathname)
//                         ? "bg-blue-50 text-[#016FFC]"
//                         : "text-gray-900 hover:bg-gray-50"
//                     }`}
//                   >
//                     Key Features
//                     <FaChevronDown
//                       className={`text-[10px] transition-transform ${
//                         mobileKeyFeaturesOpen ? "rotate-180" : ""
//                       }`}
//                     />
//                   </div>
//                   {mobileKeyFeaturesOpen && (
//                     <ul className="ml-4 mt-2 space-y-1">
//                       {items.map((item) => (
//                         <li
//                           key={item.key}
//                           onClick={() => {
//                             navigate(item.link);
//                             setMobileDrawerOpen(false);
//                             setMobileKeyFeaturesOpen(false);
//                           }}
//                           className={`text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors ${
//                             item.link === location.pathname
//                               ? "bg-blue-50 text-[#016FFC] font-medium"
//                               : "text-gray-600 hover:bg-gray-50"
//                           }`}
//                         >
//                           {item.label}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>

//                 {/* Support Submenu */}
//                 <li className="py-2">
//                   <div
//                     onClick={() => setMobileSupportOpen(!mobileSupportOpen)}
//                     className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${
//                       supportItems.some(
//                         (item) => item.link === location.pathname
//                       )
//                         ? "bg-blue-50 text-[#016FFC]"
//                         : "text-gray-900 hover:bg-gray-50"
//                     }`}
//                   >
//                     Support
//                     <FaChevronDown
//                       className={`text-[10px] transition-transform ${
//                         mobileSupportOpen ? "rotate-180" : ""
//                       }`}
//                     />
//                   </div>
//                   {mobileSupportOpen && (
//                     <ul className="ml-4 mt-2 space-y-1">
//                       {supportItems.map((item) => (
//                         <li
//                           key={item.key}
//                           onClick={() => {
//                             if (item.link === "#demo") {
//                               setDemoModalOpen(true);
//                               setMobileDrawerOpen(false);
//                               setMobileSupportOpen(false);
//                             } else if (item.link.startsWith("http")) {
//                               window.open(item.link, "_blank");
//                             } else {
//                               navigate(item.link);
//                               setMobileDrawerOpen(false);
//                               setMobileSupportOpen(false);
//                             }
//                           }}
//                           className={`text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors ${
//                             item.link === location.pathname
//                               ? "bg-blue-50 text-[#016FFC] font-medium"
//                               : "text-gray-600 hover:bg-gray-50"
//                           }`}
//                         >
//                           {item.label}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>
//               </ul>

//               {/* Bottom Actions */}
//               <div className="mt-8 pt-6 border-t border-gray-100 space-y-4">
//                 <div className="px-4">
//                   <NeptuneAccessDropdown
//                     onRequestDemo={handleRequestDemoClick}
//                   />
//                 </div>
//                 <div className="px-4">
//                   {isLoggedIn ? (
//                     <div className="flex flex-col items-center gap-3 py-4 bg-gray-50 rounded-xl">
//                       <div className="flex items-center gap-2 text-gray-900">
//                         <FaUserCircle size={20} />
//                         <span className="text-sm font-semibold">
//                           {roleName || "Super Admin"}
//                         </span>
//                       </div>
//                       <button
//                         onClick={handleLogout}
//                         className="text-sm font-semibold border-2 border-red-500 text-red-500 rounded-lg px-6 py-2 hover:bg-red-500 hover:text-white transition-all flex items-center gap-2 tracking-normal"
//                       >
//                         <RiLogoutBoxLine size={16} />
//                         Logout
//                       </button>
//                     </div>
//                   ) : (
//                     <Link
//                       to="/login"
//                       onClick={() => setMobileDrawerOpen(false)}
//                       className="block text-center text-sm font-medium tracking-normal text-gray-900 border-2 border-gray-300 rounded-lg px-6 py-2 hover:bg-gray-50 transition-colors"
//                     >
//                       Login
//                     </Link>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <DemoLoginModal
//         isOpen={demoModalOpen}
//         onClose={() => setDemoModalOpen(false)}
//       />
//       {/* Logout Success Message */}
//       {logoutMessage && (
//         <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-[9999] animate-slideInFromBottom">
//           <div className="bg-red-500 text-white px-5 py-2.5 rounded-lg shadow-xl flex items-center space-x-2">
//             <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//               <path
//                 fillRule="evenodd"
//                 d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
//                 clipRule="evenodd"
//               />
//             </svg>
//             <p className="font-semibold text-sm">{logoutMessage}</p>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes slideInFromBottom {
//           from {
//             opacity: 0;
//             transform: translate(-50%, 20px);
//           }
//           to {
//             opacity: 1;
//             transform: translate(-50%, 0);
//           }
//         }

//         .animate-slideInFromBottom {
//           animation: slideInFromBottom 0.5s ease-out forwards;
//         }
//       `}</style>
//     </>
//   );
// };

// export default NavBar;
import { useLocation, useNavigate, Link } from "react-router-dom";
import React, { useEffect, useState, useContext } from "react";
import { SicunetIcon } from "../Icons/Sicunet";
import NeptuneAccessDropdown from "../inputWidgets/RequestDemo";
import { FaUserCircle, FaChevronDown } from "react-icons/fa";
import { LoginContext } from "../../../lib/loginContext";
import { RiLogoutBoxLine } from "react-icons/ri";
import ProfileIcon from "../../../assets/svg/profileIcon";
import DemoLoginModal from "../../../modules/DemoPwd/DemoLoginModal";
import useSWR from "swr";
import { fetcher } from "../../../lib/api";
import { EnhancedDropdown } from "../inputWidgets/EnhancedDropdown ";
import {
  getProductItems,
  getKeyFeaturesItems,
  getSupportItems,
} from "./navbarUtils";

const NavBar = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const { isLoggedIn, userName, roleName, userId, logout } =
    useContext(LoginContext);
  const isProductPage = location.pathname.startsWith("/product/");
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [logoutMessage, setLogoutMessage] = useState("");
  const [menu, setMenu] = useState("Home");
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [demoModalOpen, setDemoModalOpen] = useState(false);
  const [mobileProductOpen, setMobileProductOpen] = useState(false);
  const [mobileKeyFeaturesOpen, setMobileKeyFeaturesOpen] = useState(false);
  const [mobileSupportOpen, setMobileSupportOpen] = useState(false);
  const [mobileLibraryOpen, setMobileLibraryOpen] = useState(false);

  // State to manage which dropdown is open
  const [openDropdown, setOpenDropdown] = useState(null);

  // Fetch categories
  const {
    data: categories,
    isLoading: categoriesLoading,
    error: categoriesError,
  } = useSWR("/categories/", fetcher);

  const toggleNavbar = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };

  const handleLogout = () => {
    logout();
    setUserDropdownOpen(false);
    setMobileDrawerOpen(false);

    setLogoutMessage("Logged out successfully");

    setTimeout(() => {
      setLogoutMessage("");
    }, 900);

    navigate("/");
  };

  // Handle dropdown toggle for desktop
  const handleDropdownToggle = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  // Handle Request Demo click - close mobile drawer
  const handleRequestDemoClick = () => {
    setMobileDrawerOpen(false);
  };

  // Close mobile drawer when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const drawer = document.getElementById("mobile-drawer");
      const dropdown = document.querySelector(".ant-dropdown");
      const userDropdown = document.getElementById("user-dropdown");
      const menuButton = document.getElementById("mobile-menu-button");

      if (
        mobileDrawerOpen &&
        drawer &&
        !drawer.contains(event.target) &&
        (!dropdown || !dropdown.contains(event.target)) &&
        (!menuButton || !menuButton.contains(event.target))
      ) {
        setMobileDrawerOpen(false);
      }

      if (
        userDropdownOpen &&
        userDropdown &&
        !userDropdown.contains(event.target) &&
        !event.target.closest(".user-dropdown-trigger")
      ) {
        setUserDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileDrawerOpen, userDropdownOpen]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get menu items from utility functions
  const productItems = getProductItems(categories);
  const items = getKeyFeaturesItems();
  const supportItems = getSupportItems(isLoggedIn);

  // Helper to get all support items flattened (for mobile Library children)
  const libraryParent = supportItems.find(
    (item) => item.isParent && item.key === "library-parent"
  );

  return (
    <>
      <div className="fixed bg-white z-20 w-full shadow-sm border-b border-gray-100">
        <div className="flex justify-between items-center py-[11px] px-6 lg:px-12 max-w-[1400px] 2xl:max-w-[1800px] mx-auto">
          {" "}
          {/* Left Section - Logo */}
          <div className="flex items-center">
            <div
              className="cursor-pointer"
              onClick={() => {
                navigate("/");
                setMenu("Home");
              }}
            >
              <SicunetIcon />
            </div>
          </div>
          {/* Center Section - Menu Items */}
          <div className="hidden lg:flex items-center  gap-[66px]">
            <div
              className={`relative text-sm font-medium tracking-normal cursor-pointer transition-colors pl-0 lg:pl-4 xl:pl-0 ${location.pathname === "/"
                  ? "text-[#016FFC]"
                  : "text-gray-900 hover:text-[#016FFC]"
                }`}
              onClick={() => {
                navigate("/");
                setMenu("Home");
              }}
            >
              Home
            </div>
            <div
              className={`relative text-sm font-medium tracking-normal cursor-pointer transition-colors ${location.pathname === "/company"
                  ? "text-[#016FFC]"
                  : "text-gray-900 hover:text-[#016FFC]"
                }`}
              onClick={() => {
                navigate("/company");
                setMenu("Company");
              }}
            >
              Company
            </div>
            <div
              className={`relative text-sm font-medium tracking-normal flex items-center gap-2 transition-colors ${location.pathname === "/product" ||
                  productItems.some(
                    (item) =>
                      item.link === `${location.pathname}${location.search}`
                  )
                  ? "text-[#016FFC]"
                  : "text-gray-900 hover:text-[#016FFC]"
                }`}
            >
              <EnhancedDropdown
                items={productItems}
                label="Products"
                isProductPage={isProductPage}
                currentPath={location.pathname}
                currentSearch={location.search}
                isOpen={openDropdown === "products"}
                onOpenChange={(isOpen) =>
                  setOpenDropdown(isOpen ? "products" : null)
                }
                isProductDropdown={true}
              />
              <FaChevronDown
                className="text-[10px] mt-[1px] cursor-pointer"
                onClick={() => handleDropdownToggle("products")}
              />
            </div>
            <div
              className={`relative text-sm font-medium tracking-normal flex items-center gap-2 transition-colors ${items.some((item) => item.link === location.pathname)
                  ? "text-[#016FFC]"
                  : "text-gray-900 hover:text-[#016FFC]"
                }`}
            >
              <EnhancedDropdown
                items={items}
                label="Key Features"
                isProductPage={isProductPage}
                currentPath={location.pathname}
                isOpen={openDropdown === "features"}
                onOpenChange={(isOpen) =>
                  setOpenDropdown(isOpen ? "features" : null)
                }
              />
              <FaChevronDown
                className="text-[10px] mt-[1px] cursor-pointer"
                onClick={() => handleDropdownToggle("features")}
              />
            </div>
            <div
              className={`relative text-sm font-medium tracking-normal flex items-center gap-2 transition-colors ${supportItems.some((item) => item.link === location.pathname)
                  ? "text-[#016FFC]"
                  : "text-gray-900 hover:text-[#016FFC]"
                }`}
            >
              <EnhancedDropdown
                items={supportItems}
                label="Support"
                isProductPage={isProductPage}
                currentPath={location.pathname}
                onDemoClick={() => setDemoModalOpen(true)}
                isOpen={openDropdown === "support"}
                onOpenChange={(isOpen) =>
                  setOpenDropdown(isOpen ? "support" : null)
                }
              />
              <FaChevronDown
                className="text-[10px] mt-[1px] cursor-pointer"
                onClick={() => handleDropdownToggle("support")}
              />
            </div>
          </div>
          {/* Right Section - Request Demo + Login */}
          <div className="flex items-center gap-4">
            {/* Mobile menu toggle - visible on mobile */}
            <div className="lg:hidden">
              <button
                id="mobile-menu-button"
                onClick={toggleNavbar}
                className="p-2 hover:bg-gray-50 rounded-lg transition-all"
                style={{ color: "#1a1a1a" }}
                aria-label={mobileDrawerOpen ? "Close menu" : "Open menu"}
              >
                {mobileDrawerOpen ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                  </svg>
                )}
              </button>
            </div>

            {/* Desktop items - hidden on mobile */}
            <div className="hidden lg:flex items-center gap-4">
              <NeptuneAccessDropdown />
              {isLoggedIn ? (
                <div className="relative">
                  <button
                    onClick={toggleUserDropdown}
                    className="user-dropdown-trigger flex items-center gap-2 text-gray-900 text-sm font-medium rounded-full px-2 py-2 hover:bg-gray-50 transition-all"
                  >
                    <ProfileIcon className="w-8 h-8 rounded-full" />
                  </button>
                  {userDropdownOpen && (
                    <div
                      id="user-dropdown"
                      className="absolute right-0 mt-2 w-52 bg-white rounded-xl shadow-lg py-2 z-50 border border-gray-100"
                    >
                      <div className="px-4 py-3 border-b border-gray-100">
                        <p className="text-sm font-semibold text-gray-900 truncate">
                          {roleName || "Super Admin"}
                        </p>
                      </div>
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 transition-colors font-medium"
                      >
                        <RiLogoutBoxLine size={18} />
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to="/login"
                  className="text-sm font-medium tracking-normal text-gray-900 hover:text-[#016FFC] transition-colors border-2 border-gray-300 hover:border-[#016FFC] px-5 py-1.5 rounded-lg"
                >
                  Login
                </Link>
              )}
            </div>
          </div>
        </div>

        {mobileDrawerOpen && (
          <div
            id="mobile-drawer"
            className="fixed top-[64px] left-0 right-0 bottom-0 z-30 bg-white w-full overflow-y-auto lg:hidden border-t border-gray-100 shadow-lg"
          >
            <div className="p-6">
              <ul className="space-y-1">
                <li
                  className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg transition-colors cursor-pointer ${location.pathname === "/"
                      ? "bg-blue-50 text-[#016FFC]"
                      : "text-gray-900 hover:bg-gray-50"
                    }`}
                  onClick={() => {
                    navigate("/");
                    setMenu("Home");
                    setMobileDrawerOpen(false);
                  }}
                >
                  Home
                </li>
                <li
                  className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg transition-colors cursor-pointer ${location.pathname === "/company"
                      ? "bg-blue-50 text-[#016FFC]"
                      : "text-gray-900 hover:bg-gray-50"
                    }`}
                  onClick={() => {
                    navigate("/company");
                    setMenu("Company");
                    setMobileDrawerOpen(false);
                  }}
                >
                  Company
                </li>

                {/* Product Submenu */}
                <li className="py-2">
                  <div
                    onClick={() => setMobileProductOpen(!mobileProductOpen)}
                    className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${location.pathname === "/product" ||
                        productItems.some(
                          (item) =>
                            item.link === `${location.pathname}${location.search}`
                        )
                        ? "bg-blue-50 text-[#016FFC]"
                        : "text-gray-900 hover:bg-gray-50"
                      }`}
                  >
                    Products
                    <FaChevronDown
                      className={`text-[10px] transition-transform ${mobileProductOpen ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                  {mobileProductOpen && (
                    <ul className="ml-4 mt-2 space-y-1">
                      {productItems.map((item) => (
                        <li
                          key={item.key}
                          onClick={() => {
                            navigate(item.link);
                            setMobileDrawerOpen(false);
                            setMobileProductOpen(false);
                          }}
                          className={`text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors ${item.link ===
                              `${location.pathname}${location.search}`
                              ? "bg-blue-50 text-[#016FFC] font-medium"
                              : "text-gray-600 hover:bg-gray-50"
                            }`}
                        >
                          {item.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>

                {/* Key Features Submenu */}
                <li className="py-2">
                  <div
                    onClick={() =>
                      setMobileKeyFeaturesOpen(!mobileKeyFeaturesOpen)
                    }
                    className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${items.some((item) => item.link === location.pathname)
                        ? "bg-blue-50 text-[#016FFC]"
                        : "text-gray-900 hover:bg-gray-50"
                      }`}
                  >
                    Key Features
                    <FaChevronDown
                      className={`text-[10px] transition-transform ${mobileKeyFeaturesOpen ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                  {mobileKeyFeaturesOpen && (
                    <ul className="ml-4 mt-2 space-y-1">
                      {items.map((item) => (
                        <li
                          key={item.key}
                          onClick={() => {
                            navigate(item.link);
                            setMobileDrawerOpen(false);
                            setMobileKeyFeaturesOpen(false);
                          }}
                          className={`text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors ${item.link === location.pathname
                              ? "bg-blue-50 text-[#016FFC] font-medium"
                              : "text-gray-600 hover:bg-gray-50"
                            }`}
                        >
                          {item.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>

                {/* Support Submenu */}
                <li className="py-2">
                  <div
                    onClick={() => setMobileSupportOpen(!mobileSupportOpen)}
                    className={`text-sm font-medium tracking-normal py-3 px-4 rounded-lg cursor-pointer flex items-center justify-between ${supportItems.some(
                      (item) => item.link === location.pathname
                    )
                        ? "bg-blue-50 text-[#016FFC]"
                        : "text-gray-900 hover:bg-gray-50"
                      }`}
                  >
                    Support
                    <FaChevronDown
                      className={`text-[10px] transition-transform ${mobileSupportOpen ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                  {mobileSupportOpen && (
                    <ul className="ml-4 mt-2 space-y-1">
                      {supportItems.map((item) => {
                        // Render Library parent as a nested expandable in mobile
                        if (item.isParent) {
                          return (
                            <li key={item.key}>
                              <div
                                onClick={() =>
                                  setMobileLibraryOpen(!mobileLibraryOpen)
                                }
                                className="text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors text-gray-600 hover:bg-gray-50 flex items-center justify-between font-medium"
                              >
                                {item.label}
                                <FaChevronDown
                                  className={`text-[10px] transition-transform ${mobileLibraryOpen ? "rotate-180" : ""
                                    }`}
                                />
                              </div>
                              {mobileLibraryOpen && (
                                <ul className="ml-4 mt-1 space-y-1">
                                  {item.children?.map((child) => (
                                    <li
                                      key={child.key}
                                      onClick={() => {
                                        navigate(child.link);
                                        setMobileDrawerOpen(false);
                                        setMobileSupportOpen(false);
                                        setMobileLibraryOpen(false);
                                      }}
                                      className={`text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors ${child.link === location.pathname
                                          ? "bg-blue-50 text-[#016FFC] font-medium"
                                          : "text-gray-500 hover:bg-gray-50"
                                        }`}
                                    >
                                      {child.label}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        }

                        return (
                          <li
                            key={item.key}
                            onClick={() => {
                              if (item.link === "#demo") {
                                setDemoModalOpen(true);
                                setMobileDrawerOpen(false);
                                setMobileSupportOpen(false);
                              } else if (item.link.startsWith("http")) {
                                window.open(item.link, "_blank");
                              } else {
                                navigate(item.link);
                                setMobileDrawerOpen(false);
                                setMobileSupportOpen(false);
                              }
                            }}
                            className={`text-sm py-2.5 px-4 rounded-lg cursor-pointer transition-colors ${item.link === location.pathname
                                ? "bg-blue-50 text-[#016FFC] font-medium"
                                : "text-gray-600 hover:bg-gray-50"
                              }`}
                          >
                            {item.label}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              </ul>

              {/* Bottom Actions */}
              <div className="mt-8 pt-6 border-t border-gray-100 space-y-4">
                <div className="px-4">
                  <NeptuneAccessDropdown
                    onRequestDemo={handleRequestDemoClick}
                  />
                </div>
                <div className="px-4">
                  {isLoggedIn ? (
                    <div className="flex flex-col items-center gap-3 py-4 bg-gray-50 rounded-xl">
                      <div className="flex items-center gap-2 text-gray-900">
                        <FaUserCircle size={20} />
                        <span className="text-sm font-semibold">
                          {roleName || "Super Admin"}
                        </span>
                      </div>
                      <button
                        onClick={handleLogout}
                        className="text-sm font-semibold border-2 border-red-500 text-red-500 rounded-lg px-6 py-2 hover:bg-red-500 hover:text-white transition-all flex items-center gap-2 tracking-normal"
                      >
                        <RiLogoutBoxLine size={16} />
                        Logout
                      </button>
                    </div>
                  ) : (
                    <Link
                      to="/login"
                      onClick={() => setMobileDrawerOpen(false)}
                      className="block text-center text-sm font-medium tracking-normal text-gray-900 border-2 border-gray-300 rounded-lg px-6 py-2 hover:bg-gray-50 transition-colors"
                    >
                      Login
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <DemoLoginModal
        isOpen={demoModalOpen}
        onClose={() => setDemoModalOpen(false)}
      />
      {/* Logout Success Message */}
      {logoutMessage && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-[9999] animate-slideInFromBottom">
          <div className="bg-red-500 text-white px-5 py-2.5 rounded-lg shadow-xl flex items-center space-x-2">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                clipRule="evenodd"
              />
            </svg>
            <p className="font-semibold text-sm">{logoutMessage}</p>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideInFromBottom {
          from {
            opacity: 0;
            transform: translate(-50%, 20px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }

        .animate-slideInFromBottom {
          animation: slideInFromBottom 0.5s ease-out forwards;
        }
      `}</style>
    </>
  );
};

export default NavBar;
